import styled from 'styled-components';
import { typeScale } from 'core/utils';

export const Section = styled.section`
	padding: ${typeScale(1)} 0;
	text-align: center;
	@media (min-width: 1024px) {
		padding: ${typeScale(6)} 0;
	}
`;
